import ForgotPassword from "./forgot-password.container";

export default ForgotPassword;